import { getTokenAndLocation, getTokenAndKey, copyText } from '@/utils';
import {
  createMallOrder,
  getSignResult,
  activeCard,
  signedGoodsList,
} from '@/api/tiktokSign';
import { CardService } from '@/service/card';
import { env } from '@hb/hbridge';
import { startPolling } from '@/utils/tools.js';
import { getVersion, getSystemCode } from '@/utils/systemCode';
/**
 * 创建订单
 * @param {Object} params - 请求参数，必须包含以下属性：
 * @param {number} params.orderType - 订单类型，必填
 * @param {number} params.payAmount - 支付金额，必填
 * @param {number} params.chargeType - 支付类型，必填
 * @param {Array} params.itemList - 商品列表，必填
 * @returns {Promise<void>} 无返回值，仅执行创建订单操作
 */
export async function createOrder(params) {
  const {
    token, cityCode, adCode, longitude: lon, latitude: lat,
  } = await getTokenAndLocation({ needLogin: true });
  const baseParams = {
    token,
    cityCode,
    adCode,
    lon,
    lat,
    ...params,
  };
  try {
    const { data: payOrderInfo, code, msg } = await createMallOrder(baseParams);
    if (code !== 0) {
      return {
        success: false,
        code,
        msg,
      };
    }
    return {
      success: true,
      payOrderInfo,
      code,
      msg,
    };
  } catch (error) {
    return {
      success: false,
      msg: error.message,
    };
  }
}


/**
 * 调用抖音签约并支付组件
 */
export async function callDouYinPayAndSign(params) {
  // eslint-disable-next-line no-console
  console.log('callDouYinPayAndSign params ====>', params);
  return new Promise((resolve) => {
    CardService.payTiktokMoney(params).then(() => {
      resolve({
        success: true,
      });
    }).catch(() => {
      resolve({
        success: false,
      });
    });
  });
}

/**
 * 调用抖音仅签约不支付组件
 */
export async function callDouYinSign(params) {
  // eslint-disable-next-line no-console
  console.log('callDouYinSign params ====>', params);
  return new Promise((resolve) => {
    CardService.signWithoutPasswordContractTwo({
      sceneType: 'RIDE',
      signChannel: 'douyin',
      actionOrigin: 'ttCard',
      ...params,
    }).then(() => {
      resolve({
        success: true,
      });
    }).catch((error) => {
      resolve({
        success: false,
        error,
      });
    });
  });
}

/**
 * 查询签约结果
 */
export async function queryDouYinSignResult(params) {
  const { token, userNewId } = await getTokenAndKey();
  return new Promise((resolve) => {
    // 签约完成后，轮循拿签约结果，拿到结果签约成功后调用激活接口,startPolling是轮循方法，timeout为最大轮循时间
    const { planType, ...others } = params;
    startPolling({
      requestFn: () => getSignResult({
        token,
        userNewId,
        planType,
      }),
      ...others,
      callback: (res) => {
        // 如果超过超时时间还没有拿到签约结果，则Toast提示签约超时
        if (res.end) {
          resolve({
            signIn: false,
          });
          // 超时停止轮循
          return true;
        }
        if (res.code === 0 && res.data && res.data.signIn) {
          resolve({
            signIn: true,
          });
          // 拿到结果后停止轮循
          return true;
        }
        return false;
      },
    });
  });
}

/**
 * 激活卡
 */
export async function activeCardHelper(params) {
  const { cityCode, userNewId, token } = await getTokenAndLocation();
  return new Promise((resolve) => {
    activeCard({
      token,
      cityCode,
      userNewId,
      ...params,
    }).then((activeRes) => {
      if (activeRes.code === 0) {
        resolve({
          success: true,
        });
      } else {
        resolve({
          success: false,
          message: activeRes.msg,
        });
      }
    }).catch((e) => {
      resolve({
        success: false,
        message: e.message,
      });
    });
  });
}

// 商品列表数据适配
function goodsListAdp(list = []) {
  return list.map((item) => {
    const goodsList = [{
      skuId: item.skuId,
      spuId: item.spuId,
      num: 1,
      salePrice: item.salePrice,
    }];
    return {
      ...item,
      goodsList,
      icon: item.picUrl,
      title: item.goodsName,
      subtitle: item.shortRemark,
      originalPrice: item.originalPrice,
      buyButtonText: `仅${item.salePrice}元`,
    };
  });
}

/**
 * 查询购卡后售卖商品列表
 */
export async function querySignedGoodsList(params = {}) {
  try {
    const {
      cityCode,
      adCode,
      userNewId,
      guid,
      token,
    } = await getTokenAndLocation();
    const res = await signedGoodsList({
      token,
      cityCode,
      adCode,
      userNewId,
      _uuid: guid,
      version: await getVersion(),
      systemCode: getSystemCode(),
      // 需求是最多展示10个商品，取11个是因为列表中可能包含主商品，需要过滤
      pageNo: 1,
      pageSize: 11,
      ...params,
    });
    if (res.code === 0) {
      return {
        success: true,
        cardList: goodsListAdp(res.data),
      };
    }
    return {
      success: true,
      cardList: [],
    };
  } catch (error) {
    return {
      success: false,
      cardList: [],
    };
  }
}

// 复制ha口令并跳转到应用市场
export async function copyHaCodeAndJumpToAppMarket(HaCode) {
  if (HaCode) {
    copyText(HaCode);
  }
  if (env.isIOS) {
    window.location.href = 'https://apps.apple.com/cn/app/true/id1165227346';
  } else if (env.isAndroid) {
    window.location.href = ('market://details?id=com.jingyao.easybike');
  }
}
